import React from 'react';

import { ReactComponent as LockIcon } from '../../assets/lock.svg';
import { useAuth } from '../../contexts/auth';
import {
	useProtectedArticleQuery,
	useProtectedContentQuery,
} from '../../util/use-protected-content';
import { ArticleContentClient } from '../article-content';
import { LoadingSpinner } from '../loading-spinner';
import {
	lockIcon as lockIconStyle,
	protectedContent as protectedContentStyle,
} from './style.module.css';

export interface ProtectedContentProps {
	protectedContentId?: string;
	articleId?: string;
}

export const ProtectedContent = ({ protectedContentId, articleId }: ProtectedContentProps) => {
	const auth = useAuth();
	if (!auth.session) throw new Error('Cannot show protected content if user is not logged in');

	if (!protectedContentId && !articleId) return <></>;

	const { data, error, loading } = protectedContentId
		? useProtectedContentQuery(protectedContentId)
		: useProtectedArticleQuery(articleId!);

	return (
		<section className={protectedContentStyle}>
			<ArticleContentClient
				renderTitle={() => (
					<LoadingSpinner loading={loading} error={error} data={data}>
						<div className={lockIconStyle}>
							<LockIcon />
							<h1>{data?.protectedContent.title}</h1>
						</div>
					</LoadingSpinner>
				)}
				summary={data?.protectedContent.summary}
				content={data?.protectedContent.content.document}
			/>
		</section>
	);
};
